/**
* jv.candidate.details.workflow.preInterviewForm.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.preInterviewForm.controller', [])
    .controller('jvCandidateDetailsWorkflowPreInterviewFormController', ['$scope','$routeParams','candidates',
        function($scope,$routeParams,candidates){
            candidates.getPreInterviewForms($routeParams.applicationId, $routeParams.stateId, function(res){
                var preInterviewForm = {};
                if(res.preInterviewForms && res.preInterviewForms.model){
                    preInterviewForm.forms = res.preInterviewForms.model.candidateInterviewForm;
                    preInterviewForm.workFlowName = res.preInterviewForms.workflowElementInfo.elementName;

                    for(var x=0; x<preInterviewForm.forms.length; x++){
                        if(!preInterviewForm.forms[x].completed)
                        {
                            preInterviewForm.forms.splice(x,1);
                        }
                    }

                    for(var y=0; y<preInterviewForm.forms.length; y++){
                        preInterviewForm.forms[y].json = $.xml2json(preInterviewForm.forms[y].content);
                        if(y === 0){
                            preInterviewForm.forms[y].expanded = true;
                        }
                        preInterviewForm.forms[y].show=true;
                    }

                    for(var i=0; i<preInterviewForm.forms.length; i++){
                        if(preInterviewForm.forms[i].json.section.element){
                            var temp = angular.copy(preInterviewForm.forms[i].json.section);
                            preInterviewForm.forms[i].json.section = null;
                            preInterviewForm.forms[i].json.section = [];
                            preInterviewForm.forms[i].json.section.push(temp);
                        }
                    }

                    $scope.formFunctions(preInterviewForm);
                }
            });
        }
    ]);